import axios from 'axios'

const returnsServices = {
  getReturns: ({ returnPortalId, params }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/returns`, {
      params: { ...params, portal_id: returnPortalId },
      paramsSerializer: { indexes: null },
    })
  },
  acceptReturn: ({ orderId, issueRefund, restock, restockLocation, issueExchangeOrderProcessing }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/accept`, {
      issue_refund: issueRefund,
      restock,
      restock_location_id: restockLocation,
      issue_exchange_order_processing: issueExchangeOrderProcessing,
    })
  },
  rejectReturn: ({ orderId, reason, notes, imageId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/reject`, {
      reject_reason: reason,
      reject_reason_text: notes,
      reject_image_id: imageId,
    })
  },
  rejectPartialReturn: ({
    orderId,
    items,
    remainingItems = false,
    issueRefund,
    restock,
    restockLocation,
    issueExchangeOrderProcessing,
  }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/partial-validation`, {
      items,
      accept_remaining_items: remainingItems,
      issue_refund: issueRefund,
      restock,
      restock_location_id: restockLocation,
      issue_exchange_order_processing: issueExchangeOrderProcessing,
    })
  },
  changeStatus: ({ orderId, status }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/status`, { status })
  },
  getReturnDetail: ({ returnId }) => axios.get(`${import.meta.env.VITE_HOST}/returns/${returnId}`),
  exportResults: ({ type, format, email, returnPortalId, filters }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/returns/export`,
      {
        type,
        format,
        email,
      },
      { params: { ...filters, portal_id: returnPortalId }, paramsSerializer: { indexes: null } }
    )
  },
  saveTrackingNumber: params => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${params.returnId}/mark-as-shipped`, {
      tracking_number: params.trackingNumber,
    })
  },
  getReturnTimeline: ({ returnId }) => axios.get(`${import.meta.env.VITE_HOST}/returns/${returnId}/timeline-events`),
  sendComment: params => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${params.resourceId}/comment`, {
      text: params.text,
      image_ids: params.imageIds,
      mentions: params.mentions,
    })
  },
  changeReturnsStatus: ({ returnPortalId, params }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/status`, params, {
      params: { portal_id: returnPortalId },
    })
  },
  schedulePickup: ({ orderId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/schedule-pickup`, payload)
  },
  generateReturnLabel: ({ resourceId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${resourceId}/generate-label`, payload)
  },
  returnPartialValidation: ({ orderId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/partial-validation`, payload)
  },
  editReturnAddress: ({ returnId, address }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/address`, address)
  },
  adjustmentRefunds: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/adjustment-refunds`, payload)
  },
  sendRefund: ({ returnId, payload }) => axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/refunds`, payload),
  editReturnCustomer: ({ returnId, customer }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/customer`, customer)
  },
  sendInstructions: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/return-instructions`, payload)
  },
  sendReturnEmail: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/contact-customer`, payload)
  },
  amendRejected: ({ orderId, payload }) => axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/amend`, payload),
  sendPaymentLink: ({ returnId }) => axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/payment-link`),
  revertCancelStatus: ({ orderId }) => axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/uncancel`),
  getRefundMethodExtra: ({ returnId, refundMethod, amount }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/refund-method-extra`, {
      refund_method: refundMethod,
      amount,
    })
  },
  uploadProductImage: ({ resourceId, formData }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${resourceId}/image`, formData)
  },
  cancelStoreCredit: ({ orderId, notes, issueOriginalPaymentMethod }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/cancel-store-credit`, {
      notes,
      issue_original_payment_method: issueOriginalPaymentMethod,
    })
  },
  cancelGiftCard: ({ orderId, notes, issueOriginalPaymentMethod }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${orderId}/cancel-gift-card`, {
      notes,
      issue_original_payment_method: issueOriginalPaymentMethod,
    })
  },
  getGiftCard: ({ orderId }) => axios.get(`${import.meta.env.VITE_HOST}/returns/${orderId}/gift-card`),
  getVariantsBySKU: ({ storeId, sku }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/variants`, { params: { sku, store_id: storeId } })
  },
  getReturnItemsCustomsInfo: ({ resourceId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/returns/${resourceId}/items-customs-info`)
  },
  editReturnCustomsInfo: ({ resourceId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${resourceId}/items-customs-info`, payload)
  },
  getDeliveryMethods: ({ returnId }) => axios.get(`${import.meta.env.VITE_HOST}/returns/${returnId}/delivery-methods`),
  changeDeliveryMethod: ({ returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/delivery-method`, payload)
  },
  switchExchangeToRefund: ({ returnId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/switch-to-refund`)
  },
  changeRefundMethod: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/refund-method`, payload)
  },
  putRefundOnHold: ({ returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/hold-refund`, payload)
  },
  openClaim: ({ storeId, labelId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/return-labels/${labelId}/request-claim`, payload)
  },
  markAsIssued: ({ orderId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${orderId}/manual-refunds`, payload)
  },
  getDatesAndTimeRangesForSchedulePickup: ({ orderId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/returns/${orderId}/schedule-pickup`)
  },
  acceptOnHoldReturn: ({ returnId }) => axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/approve`),
  rejectOnHoldReturn: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/decline`, payload)
  },
  markAlertAsResolved: ({ returnId, alertId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/alerts/${alertId}/ignore-exception`)
  },
  modifyAmounts: ({ returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${returnId}/modify-amounts`, payload)
  },
  markAsPaid: ({ orderId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/returns/${orderId}/manual-payments`, payload)
  },
  searchOrdersForRMA: ({ storeId, query }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/orders/search`, { params: { store_id: storeId, query } })
  },
  getOrderRma: ({ returnPortalId, orderName, customerEmail }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/orders/check`, {
      portal_id: returnPortalId,
      order_number: orderName,
      customer_email: customerEmail,
    })
  },
  getProductReturnReasons: ({ storeId, returnPortalId, productId, lineItemId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/${productId}/return-reasons`, {
      params: {
        line_item_id: lineItemId,
        portal_id: returnPortalId,
      },
    })
  },
  uploadOrdersProductImage: (orderId, formData) => {
    return axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/image`, formData)
  },
  getProductsTaxonomy: ({ storeId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/exchange-products-taxonomy`)
  },
  getProductsByTaxonomy: ({ storeId, taxonomy, taxonomyValue, page, lineItemId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products`, {
      params: { [taxonomy]: taxonomyValue, page, line_item_id: lineItemId },
    })
  },
  getRecommendedExchangeProducts: ({ orderId, itemId, page = 1 }) => {
    return axios.get(
      `${import.meta.env.VITE_HOST}/orders/${orderId}/line-items/${itemId}/recommended-exchange-products`,
      {
        params: { page },
      }
    )
  },
  searchProducts: ({ storeId, search, page, lineItemId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products`, {
      params: { search, page, line_item_id: lineItemId },
    })
  },
  getVariantsByProduct: ({ storeId, productId, lineItemId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/${productId}/variants`, {
      params: {
        line_item_id: lineItemId,
      },
    })
  },
  getRecommendedExchangeVariants: ({ orderId, lineItemId, reasonId }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/orders/${orderId}/line-items/${lineItemId}/recommended-exchange-variants`,
      {
        reason_id: reasonId,
      }
    )
  },
  createRma: ({ orderId, payload }) => axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns`, payload),
  updateRma: ({ orderId, returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}`, payload)
  },
  getRmaDeliveryMethods: ({ orderId, regionId, returnId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/delivery-methods`, {
      params: { region_id: regionId, return_id: returnId },
    })
  },
  addDeliveryMethodToRma: ({ orderId, returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/delivery-method`, payload)
  },
  addRefundMethodToRma: ({ orderId, returnId, payload }) => {
    return axios.put(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/refund-method`, payload)
  },
  completeRma: ({ orderId, returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/complete`, payload)
  },
  getRmaAmountsSummary: ({ orderId, returnId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/summary-edition`)
  },
  cancelEditedRmaAmounts: ({ orderId, returnId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/summary-edition/cancel`)
  },
  saveEditedRmaAmounts: ({ orderId, returnId, payload }) => {
    return axios.post(
      `${import.meta.env.VITE_HOST}/orders/${orderId}/returns/${returnId}/summary-edition/save`,
      payload
    )
  },
  approveOnHoldTransactions: ({ transactionIds, params }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/approve`, { transaction_ids: transactionIds }, { params })
  },
  declineOnHoldTransactions: ({ transactionIds, params }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/decline`, { transaction_ids: transactionIds }, { params })
  },
  importProductValidation: ({ storeId, formData }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/returns-validation-report`, formData)
  },
  importRmasCreation: ({ storeId, formData }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/returns-imports`, formData)
  },
  getReturnReasons: ({ returnPortalId, withDeleted = null }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/return-reasons`, {
      params: { portal_id: returnPortalId, with_deleted: withDeleted },
    })
  },
  getAlertTypes: ({ returnPortalId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/alert-types`, {
      params: { portal_id: returnPortalId },
    })
  },
  createExchangeOrder: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/create-exchange-order`, payload)
  },
  getUnexpectedItems: ({ returnId }) => axios.get(`${import.meta.env.VITE_HOST}/returns/${returnId}/unexpected-items`),
  confirmUnexpectedItems: ({ returnId, payload }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/unexpected-items/confirm`, payload)
  },
  addTransactionTags: ({ returnId, names }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${returnId}/tags`, { names })
  },
  removeTransactionTag: ({ returnId, name }) => {
    return axios.delete(`${import.meta.env.VITE_HOST}/returns/${returnId}/tags/${encodeURIComponent(name)}`)
  },
  getReturnNotificationPreview: ({ resourceId, notificationId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/returns/${resourceId}/notifications/${notificationId}/preview`)
  },
  resendReturnNotification: ({ resourceId, notificationId }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/returns/${resourceId}/notifications/${notificationId}/resend`)
  },
}

export default returnsServices
